import { createAPI } from '@common'
export default {
  // 根据docLibID获取其根文件夹ID
  getRootIdByDocLibID: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0gpmefst0sppu', 'GET', config),
  // 根据docLibID获取其根文件夹ID
  getFoldersAdmin: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0gpmefst0benjo', 'GET', config),
  // 根据docLibID获取其根文件夹ID权限
  getFolders: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0f60gpmefst', 'GET', config),  
  // 根据docLibID获取其根文件夹ID
  postCopy: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0dpnnboe0dpqz', 'POST', config),
  postDelete: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0dpnnboe0efmfuf', 'POST', config),
  postPublish: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0dpnnboe0qvcmjti', 'POST', config),
  // 新建初始化
  getInitialization: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0dpnnboe0dsfbujpo0jojujbmj{bujpo', 'GET', config),
  getTenants: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0dpnnboe0ufobout', 'GET', config),
  postCreate: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0dpnnboe0dsfbuf', 'POST', config),
  getDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0dpnnboe0efubjm', 'GET', config),
  postExport: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0dpnnboe0gffecbdl0fyqpsu', 'POST', config)
}
